import { addDays, addMonths, addWeeks, parseISO } from "date-fns";
import { useState } from "react";
import { TASK_ROW_HEIGHT } from "@/common/constants";
import { Calendar } from "../ui/calendar";
import { Command, CommandGroup, CommandItem, CommandList, CommandSeparator } from "../ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Separator } from "../ui/separator";

interface DueDateSelectProps {
    value: string | null | undefined;
    onChange: (date: Date | null) => void;
    trigger: (value: any) => React.ReactElement;
}

export default function DueDateSelect({ value, onChange, trigger }: DueDateSelectProps) {
    const [open, setOpen] = useState(false);

    const handleSelect = (date: Date | undefined) => {
        onChange(date ? new Date(date) : null);
        setOpen(false);
    };

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger render={trigger(value)} />
            <PopoverContent sideOffset={-TASK_ROW_HEIGHT} align="start" className="p-0 w-auto gap-0!">
                <Calendar
                    mode="single"
                    onSelect={handleSelect}
                    selected={value ? parseISO(value) : undefined}
                    defaultMonth={value ? parseISO(value) : undefined}
                />
                <Separator />
                <Command value={value || "none"}>
                    <CommandList>
                        <CommandGroup>
                            <CommandGroup>
                                <CommandItem onSelect={() => handleSelect(new Date())}>Today</CommandItem>
                                <CommandItem onSelect={() => handleSelect(addDays(new Date(), 1))}>Tomorrow</CommandItem>
                                <CommandItem onSelect={() => handleSelect(addWeeks(new Date(), 1))}>Next week</CommandItem>
                                <CommandItem onSelect={() => handleSelect(addMonths(new Date(), 1))}>Next month</CommandItem>
                            </CommandGroup>
                            <CommandSeparator />
                            <CommandGroup>
                                <CommandItem onSelect={() => handleSelect(undefined)}>Clear</CommandItem>
                            </CommandGroup>
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
